// // import React, { useState, useEffect } from 'react';
// // import { useAuth } from '../context/AuthContext';

// // // ==================== DATA (your original identity content) ====================
// // const business = {
// //   name: 'Sun Infosystem',
// //   tagline: 'Identity Card · PVC/RFID · Digital Lanyard · Fitting · Accessory',
// //   description:
// //     'Sun Infosystem is a trusted provider of high-quality identity solutions, offering PVC/RFID cards, digital lanyards, fittings, and accessories. With a commitment to excellence, we serve businesses across Chhatrapati Sambhajinagar with reliable, durable, and innovative products.',
// //   rating: 5.0,
// //   reviewCount: 4,
// //   phone: '079729 92927',
// //   address: 'N-11, Sector-B, Hudco, T.V. Center, Chhatrapati Sambhajinagar, Maharashtra 431003',
// //   services: [
// //     'Digital ID Card',
// //     'Identity Card',
// //     'Lanyard Printing',
// //     'PVC Card',
// //     'Discount Cards',
// //     'RFID Card',
// //     'Wholesale & Retail',
// //   ],
// //   categories: ['ID Card', 'Digital Lanyard', 'PVC/RFID Card', 'Fitting', 'Accessory'],
// //   stats: [
// //     { label: 'Service Categories', value: '12+' },
// //     { label: 'Customer Rating', value: '4.9 ⭐' },
// //     { label: 'Happy Clients', value: '500+' },
// //     { label: 'Years Experience', value: '6+' },
// //   ],
// //   testimonial: {
// //     quote:
// //       '"Excellent and rich quality card. Sun Infosystem delivered beyond our expectations. Their attention to detail and customer service is outstanding."',
// //     author: 'Ravi Kumar',
// //     role: 'Verified Customer',
// //   },
// // };

// // // ==================== COMPONENT ====================
// // export default function LandingPageCafeStyle() {
// //   const { user } = useAuth();
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// //   const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

// //   useEffect(() => {
// //     const handleResize = () => {
// //       if (window.innerWidth >= 768 && isMenuOpen) setIsMenuOpen(false);
// //     };
// //     window.addEventListener('resize', handleResize);
// //     return () => window.removeEventListener('resize', handleResize);
// //   }, [isMenuOpen]);

// //   return (
// //     <div className="bg-[#FDF8F3] font-sans">

// //       {/* ===== NAVBAR (coffee style) ===== */}
// //       <header className="bg-white shadow-sm sticky top-0 z-50">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
// //           <div className="flex items-center gap-2">
// //             <span className="text-2xl font-bold text-[#6F4E37]">Sun</span>
// //             <span className="text-xl font-light text-[#6F4E37]">Infosystem</span>
// //             <span className="hidden sm:inline text-[10px] font-medium text-[#6F4E37] bg-[#F5E6D3] px-2 py-0.5 rounded-full">
// //               ID · PVC · RFID
// //             </span>
// //           </div>
// //           <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-[#2C1810]">
// //             <a href="#services" className="hover:text-[#C67B3D]">Services</a>
// //             <a href="#about" className="hover:text-[#C67B3D]">About</a>
// //             <a href="#contact" className="hover:text-[#C67B3D]">Contact</a>
// //             {!user ? (
// //               <a href="#/login" className="border-2 border-[#6F4E37] text-[#6F4E37] px-4 py-1.5 rounded-full hover:bg-[#6F4E37] hover:text-white transition">
// //                 Login
// //               </a>
// //             ) : (
// //               <a href="#/dashboard" className="bg-[#6F4E37] text-white px-4 py-1.5 rounded-full hover:bg-[#5a3d2b] transition">
// //                 Dashboard
// //               </a>
// //             )}
// //             <a href={`tel:${business.phone.replace(/\s/g,'')}`} className="bg-[#6F4E37] text-white px-4 py-1.5 rounded-full hover:bg-[#5a3d2b] transition">
// //               <i className="fas fa-phone mr-1.5"></i> Call Now
// //             </a>
// //           </nav>
// //           <button className="md:hidden text-2xl text-[#6F4E37]" onClick={toggleMenu}>
// //             <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
// //           </button>
// //         </div>
// //         {/* mobile menu */}
// //         {isMenuOpen && (
// //           <div className="md:hidden px-4 pb-4 bg-white border-t border-[#F5E6D3] flex flex-col gap-3">
// //             <a href="#services" className="text-sm font-medium py-1" onClick={toggleMenu}>Services</a>
// //             <a href="#about" className="text-sm font-medium py-1" onClick={toggleMenu}>About</a>
// //             <a href="#contact" className="text-sm font-medium py-1" onClick={toggleMenu}>Contact</a>
// //             {!user ? (
// //               <a href="#/login" className="border-2 border-[#6F4E37] text-[#6F4E37] px-4 py-1.5 rounded-full text-center" onClick={toggleMenu}>Login</a>
// //             ) : (
// //               <a href="#/dashboard" className="bg-[#6F4E37] text-white px-4 py-1.5 rounded-full text-center" onClick={toggleMenu}>Dashboard</a>
// //             )}
// //             <a href={`tel:${business.phone.replace(/\s/g,'')}`} className="bg-[#6F4E37] text-white px-4 py-1.5 rounded-full text-center" onClick={toggleMenu}>
// //               <i className="fas fa-phone mr-1.5"></i> Call Now
// //             </a>
// //           </div>
// //         )}
// //       </header>

// //       {/* ===== HERO (coffee layout, identity content) ===== */}
// //       <section className="relative bg-[#FDF8F3] pt-12 pb-16 md:pt-20 md:pb-28 overflow-hidden">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
// //           <div className="space-y-6 text-center md:text-left">
// //             <div className="flex flex-wrap justify-center md:justify-start gap-3">
// //               <span className="inline-block bg-[#6F4E37]/10 text-[#6F4E37] text-xs font-semibold px-4 py-1.5 rounded-full">
// //                 <i className="fas fa-check-circle mr-1.5"></i> Trusted Since 2020
// //               </span>
// //               <div className="bg-white border border-[#F5E6D3] px-3 py-1.5 rounded-full flex items-center gap-2 text-sm font-semibold text-[#2C1810]">
// //                 <span className="text-yellow-500"><i className="fas fa-star"></i></span>
// //                 <span>{business.rating}</span>
// //                 <span className="text-gray-400 font-normal text-xs">({business.reviewCount} reviews)</span>
// //               </div>
// //             </div>

// //             <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold leading-tight text-[#2C1810]">
// //               Premium <br />
// //               <span className="text-[#6F4E37]">Identity</span> <br />
// //               <span className="bg-[#6F4E37] text-white px-4 py-1 inline-block rounded-lg">Solutions</span>
// //             </h1>

// //             <p className="text-gray-600 max-w-md mx-auto md:mx-0 leading-relaxed">
// //               {business.description}
// //             </p>

// //             <div className="flex flex-wrap justify-center md:justify-start gap-4 pt-2">
// //               <a href="#services" className="bg-[#6F4E37] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#5a3d2b] transition shadow-lg">
// //                 Explore Services
// //               </a>
// //               <a href="#contact" className="border-2 border-[#6F4E37] text-[#6F4E37] px-8 py-3 rounded-full font-semibold hover:bg-[#6F4E37] hover:text-white transition">
// //                 <i className="fas fa-map-pin mr-2"></i> Visit Us
// //               </a>
// //             </div>

// //             <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 text-sm text-gray-500">
// //               <span><i className="fas fa-phone mr-2 text-[#6F4E37]"></i> {business.phone}</span>
// //               <span><i className="fas fa-map-marker-alt mr-2 text-[#6F4E37]"></i> Chhatrapati Sambhajinagar</span>
// //             </div>
// //           </div>
// //           <div className="flex justify-center">
// //             <div className="w-64 h-64 md:w-80 md:h-80 rounded-full bg-[#6F4E37]/10 flex items-center justify-center border-4 border-[#6F4E37]/20">
// //               <span className="text-7xl">🪪</span>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* ===== ABOUT & STATS ===== */}
// //       <section id="about" className="py-16 bg-white">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
// //           <div className="order-2 md:order-1">
// //             <span className="text-xs font-bold uppercase tracking-widest text-[#6F4E37]">About Us</span>
// //             <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810] mt-2">
// //               Excellence in <span className="text-[#6F4E37]">Identity</span>
// //             </h2>
// //             <p className="text-gray-600 mt-4 leading-relaxed">
// //               Sun Infosystem is dedicated to delivering top-tier identity products and digital services.
// //               From PVC/RFID cards to digital lanyards and software development,
// //               we combine quality craftsmanship with modern technology.
// //             </p>
// //             <div className="grid grid-cols-2 gap-4 mt-6">
// //               {business.stats.map((stat, i) => (
// //                 <div key={i} className="bg-[#FDF8F3] p-4 rounded-xl border border-[#F5E6D3]">
// //                   <div className="text-2xl font-extrabold text-[#6F4E37]">{stat.value}</div>
// //                   <div className="text-xs text-gray-500">{stat.label}</div>
// //                 </div>
// //               ))}
// //             </div>
// //             <div className="flex flex-wrap gap-2 mt-4">
// //               {business.categories.map((cat, i) => (
// //                 <span key={i} className="bg-[#FDF8F3] border border-[#F5E6D3] text-xs font-medium px-3 py-1.5 rounded-full text-[#2C1810]">
// //                   {cat}
// //                 </span>
// //               ))}
// //             </div>
// //           </div>
// //           <div className="order-1 md:order-2 flex justify-center">
// //             <div className="w-full max-w-sm h-64 bg-[#F5E6D3] rounded-3xl flex items-center justify-center text-6xl">
// //               🏷️
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* ===== SERVICES (grid) ===== */}
// //       <section id="services" className="py-16 bg-[#FDF8F3]">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //           <div className="text-center mb-12">
// //             <span className="text-xs font-bold uppercase tracking-widest text-[#6F4E37]">What We Offer</span>
// //             <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810] mt-2">Our <span className="text-[#6F4E37]">Services</span></h2>
// //           </div>
// //           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
// //             {business.services.map((service, idx) => {
// //               const icons = {
// //                 'Application Develop': 'fa-code',
// //                 'Business Solutions': 'fa-briefcase',
// //                 'Digital ID Card': 'fa-id-card',
// //                 'Identity Card': 'fa-address-card',
// //                 'Lanyard Printing': 'fa-print',
// //                 'PVC Card': 'fa-credit-card',
// //                 'Discount Cards': 'fa-credit-card',
// //                 'RFID Card': 'fa-microchip',
// //                 'Software Development': 'fa-laptop-code',
// //                 'Web Development': 'fa-globe',
// //                 'Website Designing': 'fa-paint-brush',
// //                 'Wholesale & Retail': 'fa-store',
// //               };
// //               return (
// //                 <div key={idx} className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition border border-[#F5E6D3] hover:border-[#6F4E37] group">
// //                   <div className="w-16 h-16 mx-auto bg-[#6F4E37]/10 rounded-full flex items-center justify-center text-3xl text-[#6F4E37] group-hover:bg-[#6F4E37] group-hover:text-white transition">
// //                     <i className={`fas ${icons[service] || 'fa-cube'}`}></i>
// //                   </div>
// //                   <h3 className="text-lg font-bold text-[#2C1810] mt-4">{service}</h3>
// //                   <p className="text-sm text-gray-500 mt-1">
// //                     {service.includes('Card') ? 'Identity solution' :
// //                      service.includes('Development') || service.includes('Designing') ? 'Digital service' :
// //                      service.includes('Wholesale') ? 'Bulk supply' : 'Professional service'}
// //                   </p>
// //                 </div>
// //               );
// //             })}
// //           </div>
// //         </div>
// //       </section>

// //       {/* ===== TESTIMONIALS / CUSTOMER FEEDBACK (coffee style) ===== */}
// //       <section className="py-16 bg-[#6F4E37] text-white">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //           <div className="text-center mb-12">
// //             <h2 className="text-3xl md:text-4xl font-bold">Customer Feedback</h2>
// //           </div>
// //           <div className="max-w-3xl mx-auto bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
// //             <div className="flex items-start gap-4">
// //               <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center text-2xl flex-shrink-0">💬</div>
// //               <div>
// //                 <p className="text-lg italic leading-relaxed">{business.testimonial.quote}</p>
// //                 <div className="mt-4 flex items-center gap-3">
// //                   <div className="w-10 h-10 rounded-full bg-white/30 flex items-center justify-center font-bold">RK</div>
// //                   <div>
// //                     <div className="font-bold">{business.testimonial.author}</div>
// //                     <div className="text-sm opacity-80">{business.testimonial.role}</div>
// //                   </div>
// //                 </div>
// //                 <div className="flex gap-1 mt-2 text-yellow-400">
// //                   <i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* ===== BLOG / NEWS (can be used for articles about identity solutions) ===== */}
// //       {/* <section className="py-16 bg-white">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //           <div className="text-center mb-12">
// //             <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810]">Latest <span className="text-[#6F4E37]">News</span></h2>
// //           </div>
// //           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
// //             {[
// //               { title: 'New PVC ID Cards with RFID Technology', tag: 'Innovation' },
// //               { title: 'Digital Lanyards for Modern Workplaces', tag: 'Trends' },
// //               { title: 'How to Choose the Right ID Card Solution', tag: 'Guide' },
// //             ].map((post, i) => (
// //               <div key={i} className="bg-[#FDF8F3] rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition border border-[#F5E6D3]">
// //                 <div className="h-48 bg-[#F5E6D3] flex items-center justify-center text-5xl">📰</div>
// //                 <div className="p-5">
// //                   <span className="text-xs font-bold text-[#6F4E37] uppercase tracking-wider">{post.tag}</span>
// //                   <h3 className="text-lg font-bold text-[#2C1810] mt-2">{post.title}</h3>
// //                   <a href="#" className="inline-block mt-3 text-sm font-semibold text-[#6F4E37] hover:underline">Read More →</a>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section> */}

// //       {/* ===== CONTACT (address & phone) ===== */}
// //       <section id="contact" className="py-16 bg-[#FDF8F3]">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //           <div className="text-center mb-12">
// //             <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810]">Contact <span className="text-[#6F4E37]">Us</span></h2>
// //           </div>
// //           <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
// //             <div className="bg-white rounded-2xl p-6 shadow-md border border-[#F5E6D3] hover:border-[#6F4E37] transition">
// //               <div className="flex items-start gap-4">
// //                 <div className="w-12 h-12 bg-[#6F4E37] text-white rounded-full flex items-center justify-center flex-shrink-0">
// //                   <i className="fas fa-map-pin"></i>
// //                 </div>
// //                 <div>
// //                   <h3 className="font-bold text-[#2C1810] text-lg">Visit Our Location</h3>
// //                   <p className="text-sm text-gray-600 mt-1">{business.address}</p>
// //                   <a href="https://maps.google.com/?q=Sun+Infosystem+Chhatrapati+Sambhajinagar" target="_blank" rel="noopener noreferrer" className="inline-block mt-3 text-sm font-semibold text-[#6F4E37] hover:underline">
// //                     <i className="fas fa-external-link-alt mr-1.5"></i> Open in Maps
// //                   </a>
// //                 </div>
// //               </div>
// //             </div>
// //             <div className="bg-white rounded-2xl p-6 shadow-md border border-[#F5E6D3] hover:border-[#6F4E37] transition">
// //               <div className="flex items-start gap-4">
// //                 <div className="w-12 h-12 bg-[#6F4E37] text-white rounded-full flex items-center justify-center flex-shrink-0">
// //                   <i className="fas fa-phone"></i>
// //                 </div>
// //                 <div>
// //                   <h3 className="font-bold text-[#2C1810] text-lg">Call or Message</h3>
// //                   <a href={`tel:${business.phone.replace(/\s/g,'')}`} className="text-2xl font-bold text-[#2C1810] hover:text-[#6F4E37] block mt-1">{business.phone}</a>
// //                   <div className="flex flex-wrap gap-3 mt-4">
// //                     <a href={`tel:${business.phone.replace(/\s/g,'')}`} className="bg-[#6F4E37] text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#5a3d2b] transition">
// //                       <i className="fas fa-phone mr-2"></i> Call Now
// //                     </a>
// //                     <a href="#" className="border-2 border-[#6F4E37] text-[#6F4E37] px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#6F4E37] hover:text-white transition">
// //                       <i className="fas fa-envelope mr-2"></i> Email Us
// //                     </a>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* ===== FOOTER ===== */}
// //       <footer className="bg-[#2C1810] text-[#F5E6D3] py-10">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 md:grid-cols-4 gap-8">
// //           <div>
// //             <h4 className="text-xl font-bold mb-3">Sun Infosystem</h4>
// //             <p className="text-sm opacity-80">Identity solutions for modern businesses.</p>
// //           </div>
// //           <div>
// //             <h5 className="font-semibold mb-3">Quick Links</h5>
// //             <ul className="space-y-2 text-sm opacity-80">
// //               <li><a href="#services" className="hover:opacity-100">Services</a></li>
// //               <li><a href="#about" className="hover:opacity-100">About</a></li>
// //               <li><a href="#contact" className="hover:opacity-100">Contact</a></li>
// //             </ul>
// //           </div>
// //           <div>
// //             <h5 className="font-semibold mb-3">Contact</h5>
// //             <ul className="space-y-2 text-sm opacity-80">
// //               <li><i className="fas fa-phone mr-2"></i> {business.phone}</li>
// //               <li><i className="fas fa-envelope mr-2"></i> info@suninfosystem.com</li>
// //             </ul>
// //           </div>
// //           <div>
// //             <h5 className="font-semibold mb-3">Follow Us</h5>
// //             <div className="flex gap-4 text-xl">
// //               <a href="#" className="hover:text-white"><i className="fab fa-instagram"></i></a>
// //               <a href="#" className="hover:text-white"><i className="fab fa-facebook"></i></a>
// //               <a href="#" className="hover:text-white"><i className="fab fa-twitter"></i></a>
// //             </div>
// //           </div>
// //         </div>
// //         <div className="text-center text-sm opacity-60 mt-8 border-t border-white/10 pt-6">
// //           &copy; {new Date().getFullYear()} Sun Infosystem. All rights reserved.
// //         </div>
// //       </footer>

// //     </div>
// //   );
// // }

// import React, { useState, useEffect } from 'react';
// import { useAuth } from '../context/AuthContext';

// // ==================== DATA (your original identity content) ====================
// const business = {
//   name: 'Sun Infosystem',
//   tagline: 'Identity Card · PVC/RFID · Digital Lanyard · Fitting · Accessory',
//   description:
//     'Sun Infosystem is a trusted provider of high-quality identity solutions, offering PVC/RFID cards, digital lanyards, fittings, and accessories. With a commitment to excellence, we serve businesses across Chhatrapati Sambhajinagar with reliable, durable, and innovative products.',
//   rating: 5.0,
//   reviewCount: 4,
//   phone: '079729 92927',
//   address: 'N-11, Sector-B, Hudco, T.V. Center, Chhatrapati Sambhajinagar, Maharashtra 431003',
//   services: [
//     'Business Solutions',
//     'Digital ID Card',
//     'Identity Card',
//     'Lanyard Printing',
//     'PVC Card',
//     'Discount Cards',
//     'RFID Card',
//     'Wholesale & Retail',
//     'Material Supply',     // <-- NEW
//     'Sash Printing',       // <-- NEW
//   ],
//   categories: ['ID Card', 'Digital Lanyard', 'PVC/RFID Card', 'Fitting', 'Accessory'],
//   stats: [
//     { label: 'Service Categories', value: '12+' },
//     { label: 'Customer Rating', value: '4.9 ⭐' },
//     { label: 'Happy Clients', value: '500+' },
//     { label: 'Years Experience', value: '6+' },
//   ],
//   testimonial: {
//     quote:
//       '"Excellent and rich quality card. Sun Infosystem delivered beyond our expectations. Their attention to detail and customer service is outstanding."',
//     author: 'Ravi Kumar',
//     role: 'Verified Customer',
//   },
// };

// // ==================== COMPONENT ====================
// export default function LandingPageCafeStyle() {
//   const { user } = useAuth();
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth >= 768 && isMenuOpen) setIsMenuOpen(false);
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, [isMenuOpen]);

//   // Icon mapping including new services
//   const getIcon = (service) => {
//     const map = {
//       'Digital ID Card': 'fa-id-card',
//       'Identity Card': 'fa-address-card',
//       'Lanyard Printing': 'fa-print',
//       'PVC Card': 'fa-credit-card',
//       'Discount Cards': 'fa-credit-card',
//       'RFID Card': 'fa-microchip',
//       'Software Development': 'fa-laptop-code',
//       'Wholesale & Retail': 'fa-store',
//       'Material Supply': 'fa-truck',          // <-- NEW icon
//       'Sash Printing': 'fa-tshirt',           // <-- NEW icon
//     };
//     return map[service] || 'fa-cube';
//   };

//   const getServiceDescription = (service) => {
//     if (service.includes('Card')) return 'Identity solution';
//     if (service.includes('Development') || service.includes('Designing')) return 'Digital service';
//     if (service.includes('Wholesale')) return 'Bulk supply';
//     if (service === 'Material Supply') return 'Supply chain service';
//     if (service === 'Sash Printing') return 'Printing service';
//     return 'Professional service';
//   };

//   return (
//     <div className="bg-[#FDF8F3] font-sans">

//       {/* ===== NAVBAR (coffee style) ===== */}
//       <header className="bg-white shadow-sm sticky top-0 z-50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
//           <div className="flex items-center gap-2">
//             <span className="text-2xl font-bold text-[#6F4E37]">Sun</span>
//             <span className="text-xl font-light text-[#6F4E37]">Infosystem</span>
//             <span className="hidden sm:inline text-[10px] font-medium text-[#6F4E37] bg-[#F5E6D3] px-2 py-0.5 rounded-full">
//               ID · PVC · RFID
//             </span>
//           </div>
//           <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-[#2C1810]">
//             <a href="#services" className="hover:text-[#C67B3D]">Services</a>
//             <a href="#about" className="hover:text-[#C67B3D]">About</a>
//             <a href="#contact" className="hover:text-[#C67B3D]">Contact</a>
//             {!user ? (
//               <a href="#/login" className="border-2 border-[#6F4E37] text-[#6F4E37] px-4 py-1.5 rounded-full hover:bg-[#6F4E37] hover:text-white transition">
//                 Login
//               </a>
//             ) : (
//               <a href="#/dashboard" className="bg-[#6F4E37] text-white px-4 py-1.5 rounded-full hover:bg-[#5a3d2b] transition">
//                 Dashboard
//               </a>
//             )}
//             <a href={`tel:${business.phone.replace(/\s/g,'')}`} className="bg-[#6F4E37] text-white px-4 py-1.5 rounded-full hover:bg-[#5a3d2b] transition">
//               <i className="fas fa-phone mr-1.5"></i> Call Now
//             </a>
//           </nav>
//           <button className="md:hidden text-2xl text-[#6F4E37]" onClick={toggleMenu}>
//             <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
//           </button>
//         </div>
//         {/* mobile menu */}
//         {isMenuOpen && (
//           <div className="md:hidden px-4 pb-4 bg-white border-t border-[#F5E6D3] flex flex-col gap-3">
//             <a href="#services" className="text-sm font-medium py-1" onClick={toggleMenu}>Services</a>
//             <a href="#about" className="text-sm font-medium py-1" onClick={toggleMenu}>About</a>
//             <a href="#contact" className="text-sm font-medium py-1" onClick={toggleMenu}>Contact</a>
//             {!user ? (
//               <a href="#/login" className="border-2 border-[#6F4E37] text-[#6F4E37] px-4 py-1.5 rounded-full text-center" onClick={toggleMenu}>Login</a>
//             ) : (
//               <a href="#/dashboard" className="bg-[#6F4E37] text-white px-4 py-1.5 rounded-full text-center" onClick={toggleMenu}>Dashboard</a>
//             )}
//             <a href={`tel:${business.phone.replace(/\s/g,'')}`} className="bg-[#6F4E37] text-white px-4 py-1.5 rounded-full text-center" onClick={toggleMenu}>
//               <i className="fas fa-phone mr-1.5"></i> Call Now
//             </a>
//           </div>
//         )}
//       </header>

//       {/* ===== HERO (coffee layout, identity content) ===== */}
//       <section className="relative bg-[#FDF8F3] pt-12 pb-16 md:pt-20 md:pb-28 overflow-hidden">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
//           <div className="space-y-6 text-center md:text-left">
//             <div className="flex flex-wrap justify-center md:justify-start gap-3">
//               <span className="inline-block bg-[#6F4E37]/10 text-[#6F4E37] text-xs font-semibold px-4 py-1.5 rounded-full">
//                 <i className="fas fa-check-circle mr-1.5"></i> Trusted Since 2020
//               </span>
//               <div className="bg-white border border-[#F5E6D3] px-3 py-1.5 rounded-full flex items-center gap-2 text-sm font-semibold text-[#2C1810]">
//                 <span className="text-yellow-500"><i className="fas fa-star"></i></span>
//                 <span>{business.rating}</span>
//                 <span className="text-gray-400 font-normal text-xs">({business.reviewCount} reviews)</span>
//               </div>
//             </div>

//             <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold leading-tight text-[#2C1810]">
//               Premium <br />
//               <span className="text-[#6F4E37]">Identity</span> <br />
//               <span className="bg-[#6F4E37] text-white px-4 py-1 inline-block rounded-lg">Solutions</span>
//             </h1>

//             <p className="text-gray-600 max-w-md mx-auto md:mx-0 leading-relaxed">
//               {business.description}
//             </p>

//             <div className="flex flex-wrap justify-center md:justify-start gap-4 pt-2">
//               <a href="#services" className="bg-[#6F4E37] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#5a3d2b] transition shadow-lg">
//                 Explore Services
//               </a>
//               <a href="#contact" className="border-2 border-[#6F4E37] text-[#6F4E37] px-8 py-3 rounded-full font-semibold hover:bg-[#6F4E37] hover:text-white transition">
//                 <i className="fas fa-map-pin mr-2"></i> Visit Us
//               </a>
//             </div>

//             <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 text-sm text-gray-500">
//               <span><i className="fas fa-phone mr-2 text-[#6F4E37]"></i> {business.phone}</span>
//               <span><i className="fas fa-map-marker-alt mr-2 text-[#6F4E37]"></i> Chhatrapati Sambhajinagar</span>
//             </div>
//           </div>
//           <div className="flex justify-center">
//             <div className="w-64 h-64 md:w-80 md:h-80 rounded-full bg-[#6F4E37]/10 flex items-center justify-center border-4 border-[#6F4E37]/20">
//               <span className="text-7xl">🪪</span>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ===== ABOUT & STATS ===== */}
//       <section id="about" className="py-16 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
//           <div className="order-2 md:order-1">
//             <span className="text-xs font-bold uppercase tracking-widest text-[#6F4E37]">About Us</span>
//             <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810] mt-2">
//               Excellence in <span className="text-[#6F4E37]">Identity</span>
//             </h2>
//             <p className="text-gray-600 mt-4 leading-relaxed">
//               Sun Infosystem is dedicated to delivering top-tier identity products and digital services.
//               From PVC/RFID cards to digital lanyards and software development,
//               we combine quality craftsmanship with modern technology.
//             </p>
//             <div className="grid grid-cols-2 gap-4 mt-6">
//               {business.stats.map((stat, i) => (
//                 <div key={i} className="bg-[#FDF8F3] p-4 rounded-xl border border-[#F5E6D3]">
//                   <div className="text-2xl font-extrabold text-[#6F4E37]">{stat.value}</div>
//                   <div className="text-xs text-gray-500">{stat.label}</div>
//                 </div>
//               ))}
//             </div>
//             <div className="flex flex-wrap gap-2 mt-4">
//               {business.categories.map((cat, i) => (
//                 <span key={i} className="bg-[#FDF8F3] border border-[#F5E6D3] text-xs font-medium px-3 py-1.5 rounded-full text-[#2C1810]">
//                   {cat}
//                 </span>
//               ))}
//             </div>
//           </div>
//           <div className="order-1 md:order-2 flex justify-center">
//             <div className="w-full max-w-sm h-64 bg-[#F5E6D3] rounded-3xl flex items-center justify-center text-6xl">
//               🏷️
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ===== SERVICES (grid) ===== */}
//       <section id="services" className="py-16 bg-[#FDF8F3]">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-12">
//             <span className="text-xs font-bold uppercase tracking-widest text-[#6F4E37]">What We Offer</span>
//             <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810] mt-2">Our <span className="text-[#6F4E37]">Services</span></h2>
//           </div>
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//             {business.services.map((service, idx) => (
//               <div key={idx} className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition border border-[#F5E6D3] hover:border-[#6F4E37] group">
//                 <div className="w-16 h-16 mx-auto bg-[#6F4E37]/10 rounded-full flex items-center justify-center text-3xl text-[#6F4E37] group-hover:bg-[#6F4E37] group-hover:text-white transition">
//                   <i className={`fas ${getIcon(service)}`}></i>
//                 </div>
//                 <h3 className="text-lg font-bold text-[#2C1810] mt-4">{service}</h3>
//                 <p className="text-sm text-gray-500 mt-1">
//                   {getServiceDescription(service)}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ===== TESTIMONIALS / CUSTOMER FEEDBACK (coffee style) ===== */}
//       <section className="py-16 bg-[#6F4E37] text-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl md:text-4xl font-bold">Customer Feedback</h2>
//           </div>
//           <div className="max-w-3xl mx-auto bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
//             <div className="flex items-start gap-4">
//               <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center text-2xl flex-shrink-0">💬</div>
//               <div>
//                 <p className="text-lg italic leading-relaxed">{business.testimonial.quote}</p>
//                 <div className="mt-4 flex items-center gap-3">
//                   <div className="w-10 h-10 rounded-full bg-white/30 flex items-center justify-center font-bold">RK</div>
//                   <div>
//                     <div className="font-bold">{business.testimonial.author}</div>
//                     <div className="text-sm opacity-80">{business.testimonial.role}</div>
//                   </div>
//                 </div>
//                 <div className="flex gap-1 mt-2 text-yellow-400">
//                   <i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ===== BLOG / NEWS (can be used for articles about identity solutions) ===== */}
//       {/* <section className="py-16 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810]">Latest <span className="text-[#6F4E37]">News</span></h2>
//           </div>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//             {[
//               { title: 'New PVC ID Cards with RFID Technology', tag: 'Innovation' },
//               { title: 'Digital Lanyards for Modern Workplaces', tag: 'Trends' },
//               { title: 'How to Choose the Right ID Card Solution', tag: 'Guide' },
//             ].map((post, i) => (
//               <div key={i} className="bg-[#FDF8F3] rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition border border-[#F5E6D3]">
//                 <div className="h-48 bg-[#F5E6D3] flex items-center justify-center text-5xl">📰</div>
//                 <div className="p-5">
//                   <span className="text-xs font-bold text-[#6F4E37] uppercase tracking-wider">{post.tag}</span>
//                   <h3 className="text-lg font-bold text-[#2C1810] mt-2">{post.title}</h3>
//                   <a href="#" className="inline-block mt-3 text-sm font-semibold text-[#6F4E37] hover:underline">Read More →</a>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section> */}

//       {/* ===== CONTACT (address & phone) ===== */}
//       <section id="contact" className="py-16 bg-[#FDF8F3]">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810]">Contact <span className="text-[#6F4E37]">Us</span></h2>
//           </div>
//           <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
//             <div className="bg-white rounded-2xl p-6 shadow-md border border-[#F5E6D3] hover:border-[#6F4E37] transition">
//               <div className="flex items-start gap-4">
//                 <div className="w-12 h-12 bg-[#6F4E37] text-white rounded-full flex items-center justify-center flex-shrink-0">
//                   <i className="fas fa-map-pin"></i>
//                 </div>
//                 <div>
//                   <h3 className="font-bold text-[#2C1810] text-lg">Visit Our Location</h3>
//                   <p className="text-sm text-gray-600 mt-1">{business.address}</p>
//                   <a href="https://maps.google.com/?q=Sun+Infosystem+Chhatrapati+Sambhajinagar" target="_blank" rel="noopener noreferrer" className="inline-block mt-3 text-sm font-semibold text-[#6F4E37] hover:underline">
//                     <i className="fas fa-external-link-alt mr-1.5"></i> Open in Maps
//                   </a>
//                 </div>
//               </div>
//             </div>
//             <div className="bg-white rounded-2xl p-6 shadow-md border border-[#F5E6D3] hover:border-[#6F4E37] transition">
//               <div className="flex items-start gap-4">
//                 <div className="w-12 h-12 bg-[#6F4E37] text-white rounded-full flex items-center justify-center flex-shrink-0">
//                   <i className="fas fa-phone"></i>
//                 </div>
//                 <div>
//                   <h3 className="font-bold text-[#2C1810] text-lg">Call or Message</h3>
//                   <a href={`tel:${business.phone.replace(/\s/g,'')}`} className="text-2xl font-bold text-[#2C1810] hover:text-[#6F4E37] block mt-1">{business.phone}</a>
//                   <div className="flex flex-wrap gap-3 mt-4">
//                     <a href={`tel:${business.phone.replace(/\s/g,'')}`} className="bg-[#6F4E37] text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#5a3d2b] transition">
//                       <i className="fas fa-phone mr-2"></i> Call Now
//                     </a>
//                     <a href="#" className="border-2 border-[#6F4E37] text-[#6F4E37] px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#6F4E37] hover:text-white transition">
//                       <i className="fas fa-envelope mr-2"></i> Email Us
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ===== FOOTER ===== */}
//       <footer className="bg-[#2C1810] text-[#F5E6D3] py-10">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 md:grid-cols-4 gap-8">
//           <div>
//             <h4 className="text-xl font-bold mb-3">Sun Infosystem</h4>
//             <p className="text-sm opacity-80">Identity solutions for modern businesses.</p>
//           </div>
//           <div>
//             <h5 className="font-semibold mb-3">Quick Links</h5>
//             <ul className="space-y-2 text-sm opacity-80">
//               <li><a href="#services" className="hover:opacity-100">Services</a></li>
//               <li><a href="#about" className="hover:opacity-100">About</a></li>
//               <li><a href="#contact" className="hover:opacity-100">Contact</a></li>
//             </ul>
//           </div>
//           <div>
//             <h5 className="font-semibold mb-3">Contact</h5>
//             <ul className="space-y-2 text-sm opacity-80">
//               <li><i className="fas fa-phone mr-2"></i> {business.phone}</li>
//               <li><i className="fas fa-envelope mr-2"></i> info@suninfosystem.com</li>
//             </ul>
//           </div>
//           {/* <div>
//             <h5 className="font-semibold mb-3">Follow Us</h5>
//             <div className="flex gap-4 text-xl">
//               <a href="#" className="hover:text-white"><i className="fab fa-instagram"></i></a>
//               <a href="#" className="hover:text-white"><i className="fab fa-facebook"></i></a>
//               <a href="#" className="hover:text-white"><i className="fab fa-twitter"></i></a>
//             </div>
//           </div> */}
//         </div>
//         <div className="text-center text-sm opacity-60 mt-8 border-t border-white/10 pt-6">
//           &copy; {new Date().getFullYear()} Sun Infosystem. All rights reserved.
//         </div>
//       </footer>

//     </div>
//   );
// }

import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

// ===== IMPORT YOUR IMAGES =====
// Place your images in src/assets/images/ with these names
import heroImage from '../assets/hero-id.jpg';              // Hero section
import productDigital from '../assets/product-digital.jpg'; // Digital ID Card
import productDiscount from '../assets/product-discount.jpg'; // Discount Cards
import productRFID from '../assets/product-rfid.jpg';       // RFID Card
import productPVC from '../assets/product-pvc.jpg';         // PVC Card
import aboutImage from '../assets/about-us.jpg';  
// ==================== DATA ====================
const business = {
  name: 'Sun Infosystem',
  tagline: 'Identity Card · PVC/RFID · Digital Lanyard · Fitting · Accessory',
  description:
    'Sun Infosystem is a trusted provider of high-quality identity solutions, offering PVC/RFID cards, digital lanyards, fittings, and accessories. With a commitment to excellence, we serve businesses across Chhatrapati Sambhajinagar with reliable, durable, and innovative products.',
  rating: 5.0,
  reviewCount: 4,
  phone: '079729 92927',
  address: 'N-11, Sector-B, Hudco, T.V. Center, Chhatrapati Sambhajinagar, Maharashtra 431003',
  services: [
    'Lanyard Printing',
    'Wholesale & Retail',
    'Sash Printing',
    'Material Supply',
  ],
  products: [
    { name: 'Digital ID Card', image: productDigital },
    { name: 'Discount Cards', image: productDiscount },
    { name: 'RFID Card', image: productRFID },
    { name: 'PVC Card', image: productPVC },
  ],
  categories: ['ID Card', 'Digital Lanyard', 'PVC/RFID Card', 'Fitting', 'Accessory'],
  stats: [
    { label: 'Service Categories', value: '12+' },
    { label: 'Customer Rating', value: '4.9 ⭐' },
    { label: 'Happy Clients', value: '500+' },
    { label: 'Years Experience', value: '17+' },
  ],
  testimonial: {
    quote:
      '"Excellent and rich quality card. Sun Infosystem delivered beyond our expectations. Their attention to detail and customer service is outstanding."',
    author: 'Ravi Kumar',
    role: 'Verified Customer',
  },
};

// Icon mapping for services (only 4 now)
const getServiceIcon = (service) => {
  const map = {
    'Lanyard Printing': 'fa-print',
    'Wholesale & Retail': 'fa-store',
    'Sash Printing': 'fa-tshirt',
    'Material Supply': 'fa-truck',
  };
  return map[service] || 'fa-cube';
};

const getServiceDescription = (service) => {
  if (service === 'Lanyard Printing') return 'Custom lanyard printing';
  if (service === 'Wholesale & Retail') return 'Bulk supply & retail';
  if (service === 'Sash Printing') return 'Printing service';
  if (service === 'Material Supply') return 'Supply chain service';
  return 'Professional service';
};

// ==================== COMPONENT ====================
export default function LandingPageCafeStyle() {
  const { user } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768 && isMenuOpen) setIsMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMenuOpen]);

  return (
    <div className="bg-[#FDF8F3] font-sans">

      {/* ===== NAVBAR (coffee color) ===== */}
      <header className="bg-[#6F4E37] shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
          <div className="flex items-center gap-2">
            <span className="text-2xl font-bold text-white">Sun</span>
            <span className="text-xl font-light text-[#F5E6D3]">Infosystem</span>
            <span className="hidden sm:inline text-[10px] font-medium text-[#F5E6D3] bg-white/20 px-2 py-0.5 rounded-full">
              ID · PVC · RFID
            </span>
          </div>
          <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-white/90">
            <a href="#products" className="hover:text-white">Products</a>
            <a href="#services" className="hover:text-white">Services</a>
            <a href="#about" className="hover:text-white">About</a>
            <a href="#contact" className="hover:text-white">Contact</a>
            {!user ? (
              <a href="#/login" className="border-2 border-white/60 text-white px-4 py-1.5 rounded-full hover:bg-white hover:text-[#6F4E37] transition">
                Login
              </a>
            ) : (
              <a href="#/dashboard" className="bg-white text-[#6F4E37] px-4 py-1.5 rounded-full hover:bg-[#F5E6D3] transition">
                Dashboard
              </a>
            )}
            <a href={`tel:${business.phone.replace(/\s/g,'')}`} className="bg-white text-[#6F4E37] px-4 py-1.5 rounded-full hover:bg-[#F5E6D3] transition">
              <i className="fas fa-phone mr-1.5"></i> Call Now
            </a>
          </nav>
          <button className="md:hidden text-2xl text-white" onClick={toggleMenu}>
            <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
        </div>
        {/* mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden px-4 pb-4 bg-[#6F4E37] border-t border-white/10 flex flex-col gap-3">
            <a href="#products" className="text-sm font-medium text-white/90 py-1" onClick={toggleMenu}>Products</a>
            <a href="#services" className="text-sm font-medium text-white/90 py-1" onClick={toggleMenu}>Services</a>
            <a href="#about" className="text-sm font-medium text-white/90 py-1" onClick={toggleMenu}>About</a>
            <a href="#contact" className="text-sm font-medium text-white/90 py-1" onClick={toggleMenu}>Contact</a>
            {!user ? (
              <a href="#/login" className="border-2 border-white/60 text-white px-4 py-1.5 rounded-full text-center" onClick={toggleMenu}>Login</a>
            ) : (
              <a href="#/dashboard" className="bg-white text-[#6F4E37] px-4 py-1.5 rounded-full text-center" onClick={toggleMenu}>Dashboard</a>
            )}
            <a href={`tel:${business.phone.replace(/\s/g,'')}`} className="bg-white text-[#6F4E37] px-4 py-1.5 rounded-full text-center" onClick={toggleMenu}>
              <i className="fas fa-phone mr-1.5"></i> Call Now
            </a>
          </div>
        )}
      </header>

      {/* ===== HERO with AI‑generated image ===== */}
      <section className="relative bg-[#FDF8F3] pt-12 pb-16 md:pt-20 md:pb-28 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6 text-center md:text-left">
            <div className="flex flex-wrap justify-center md:justify-start gap-3">
              <span className="inline-block bg-[#6F4E37]/10 text-[#6F4E37] text-xs font-semibold px-4 py-1.5 rounded-full">
                <i className="fas fa-check-circle mr-1.5"></i> Trusted Since 2020
              </span>
              <div className="bg-white border border-[#F5E6D3] px-3 py-1.5 rounded-full flex items-center gap-2 text-sm font-semibold text-[#2C1810]">
                <span className="text-yellow-500"><i className="fas fa-star"></i></span>
                <span>{business.rating}</span>
                <span className="text-gray-400 font-normal text-xs">({business.reviewCount} reviews)</span>
              </div>
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold leading-tight text-[#2C1810]">
              Premium <br />
              <span className="text-[#6F4E37]">Identity</span> <br />
              <span className="bg-[#6F4E37] text-white px-4 py-1 inline-block rounded-lg">Solutions</span>
            </h1>

            <p className="text-gray-600 max-w-md mx-auto md:mx-0 leading-relaxed">
              {business.description}
            </p>
{/* 
            <div className="flex flex-wrap justify-center md:justify-start gap-4 pt-2">
              <a href="#products" className="bg-[#6F4E37] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#5a3d2b] transition shadow-lg">
                View Products
              </a>
              <a href="#contact" className="border-2 border-[#6F4E37] text-[#6F4E37] px-8 py-3 rounded-full font-semibold hover:bg-[#6F4E37] hover:text-white transition">
                <i className="fas fa-map-pin mr-2"></i> Visit Us
              </a>
            </div> */}

            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 text-sm text-gray-500">
              <span><i className="fas fa-phone mr-2 text-[#6F4E37]"></i> {business.phone}</span>
              <span><i className="fas fa-map-marker-alt mr-2 text-[#6F4E37]"></i> Chhatrapati Sambhajinagar</span>
            </div>
          </div>

          {/* Hero Image */}
          <div className="flex justify-center">
            <div className="relative group w-full max-w-sm rounded-3xl overflow-hidden shadow-xl border-4 border-white/50 hover:border-[#6F4E37] transition-all duration-500">
              <img
                src={heroImage}
                alt="AI generated identity card concept"
                className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105"
              />
              {/* <div className="absolute inset-0 bg-gradient-to-t from-[#6F4E37]/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-start p-4">
                <span className="bg-white/20 backdrop-blur-sm text-white text-xs font-semibold px-3 py-1.5 rounded-full border border-white/30">
                  ✨ AI Generated
                </span>
              </div>
              <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-[#6F4E37] shadow-lg">
                ✨ AI
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* ===== PRODUCTS SECTION with images ===== */}
      <section id="products" className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-xs font-bold uppercase tracking-widest text-[#6F4E37]">Our Range</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810] mt-2">Our <span className="text-[#6F4E37]">Products</span></h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {business.products.map((product, idx) => (
              <div key={idx} className="group relative bg-[#FDF8F3] rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-[#F5E6D3] hover:border-[#6F4E37]">
                <img
                  src={product.image}
                  alt={product.name}
                  className="h-52 w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                {/* <div className="absolute inset-0 bg-[#6F4E37]/0 group-hover:bg-[#6F4E37]/10 transition-colors duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
                  <span className="bg-[#6F4E37] text-white text-sm font-semibold px-4 py-2 rounded-full shadow-lg transform -translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                    <i className="fas fa-eye mr-2"></i> View Details
                  </span>
                </div> */}
                <div className="p-5 text-center">
                  <h3 className="text-lg font-bold text-[#2C1810]">{product.name}</h3>
                  <p className="text-sm text-gray-500 mt-1">Premium quality, durable & secure</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== SERVICES SECTION (only 4 services) ===== */}
      <section id="services" className="py-16 bg-[#FDF8F3]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-xs font-bold uppercase tracking-widest text-[#6F4E37]">What We Offer</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810] mt-2">Our <span className="text-[#6F4E37]">Services</span></h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {business.services.map((service, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition border border-[#F5E6D3] hover:border-[#6F4E37] group">
                <div className="w-16 h-16 mx-auto bg-[#6F4E37]/10 rounded-full flex items-center justify-center text-3xl text-[#6F4E37] group-hover:bg-[#6F4E37] group-hover:text-white transition">
                  <i className={`fas ${getServiceIcon(service)}`}></i>
                </div>
                <h3 className="text-lg font-bold text-[#2C1810] mt-4">{service}</h3>
                <p className="text-sm text-gray-500 mt-1">{getServiceDescription(service)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== ABOUT & STATS ===== */}
      <section id="about" className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1">
            <span className="text-xs font-bold uppercase tracking-widest text-[#6F4E37]">About Us</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810] mt-2">
              Excellence in <span className="text-[#6F4E37]">Identity</span>
            </h2>
            <p className="text-gray-600 mt-4 leading-relaxed">
              Sun Infosystem is dedicated to delivering top-tier identity products and digital services.
              From PVC/RFID cards to digital lanyards and software development,
              we combine quality craftsmanship with modern technology.
            </p>
            <div className="grid grid-cols-2 gap-4 mt-6">
              {business.stats.map((stat, i) => (
                <div key={i} className="bg-[#FDF8F3] p-4 rounded-xl border border-[#F5E6D3]">
                  <div className="text-2xl font-extrabold text-[#6F4E37]">{stat.value}</div>
                  <div className="text-xs text-gray-500">{stat.label}</div>
                </div>
              ))}
            </div>
            <div className="flex flex-wrap gap-2 mt-4">
              {business.categories.map((cat, i) => (
                <span key={i} className="bg-[#FDF8F3] border border-[#F5E6D3] text-xs font-medium px-3 py-1.5 rounded-full text-[#2C1810]">
                  {cat}
                </span>
              ))}
            </div>
          </div>
          <div className="order-1 md:order-2 flex justify-center">
                      <div className="w-full max-w-sm h-64 rounded-3xl overflow-hidden shadow-md border border-[#F5E6D3]">
              <img
                src={aboutImage}
                alt="About Sun Infosystem"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ===== TESTIMONIALS ===== */}
      <section className="py-16 bg-[#6F4E37] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold">Customer Feedback</h2>
          </div>
          <div className="max-w-3xl mx-auto bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center text-2xl flex-shrink-0">💬</div>
              <div>
                <p className="text-lg italic leading-relaxed">{business.testimonial.quote}</p>
                <div className="mt-4 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white/30 flex items-center justify-center font-bold">RK</div>
                  <div>
                    <div className="font-bold">{business.testimonial.author}</div>
                    <div className="text-sm opacity-80">{business.testimonial.role}</div>
                  </div>
                </div>
                <div className="flex gap-1 mt-2 text-yellow-400">
                  <i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== BLOG ===== */}
      {/* <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810]">Latest <span className="text-[#6F4E37]">News</span></h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { title: 'New PVC ID Cards with RFID Technology', tag: 'Innovation' },
              { title: 'Digital Lanyards for Modern Workplaces', tag: 'Trends' },
              { title: 'How to Choose the Right ID Card Solution', tag: 'Guide' },
            ].map((post, i) => (
              <div key={i} className="bg-[#FDF8F3] rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition border border-[#F5E6D3]">
                <div className="h-48 bg-[#F5E6D3] flex items-center justify-center text-5xl">📰</div>
                <div className="p-5">
                  <span className="text-xs font-bold text-[#6F4E37] uppercase tracking-wider">{post.tag}</span>
                  <h3 className="text-lg font-bold text-[#2C1810] mt-2">{post.title}</h3>
                  <a href="#" className="inline-block mt-3 text-sm font-semibold text-[#6F4E37] hover:underline">Read More →</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
🏷️

      {/* ===== CONTACT ===== */}
      <section id="contact" className="py-16 bg-[#FDF8F3]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810]">Contact <span className="text-[#6F4E37]">Us</span></h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-6 shadow-md border border-[#F5E6D3] hover:border-[#6F4E37] transition">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#6F4E37] text-white rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-map-pin"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#2C1810] text-lg">Visit Our Location</h3>
                  <p className="text-sm text-gray-600 mt-1">{business.address}</p>
                  <a href="https://maps.google.com/?q=Sun+Infosystem+Chhatrapati+Sambhajinagar" target="_blank" rel="noopener noreferrer" className="inline-block mt-3 text-sm font-semibold text-[#6F4E37] hover:underline">
                    <i className="fas fa-external-link-alt mr-1.5"></i> Open in Maps
                  </a>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-md border border-[#F5E6D3] hover:border-[#6F4E37] transition">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#6F4E37] text-white rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-phone"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#2C1810] text-lg">Call or Message</h3>
                  <a href={`tel:${business.phone.replace(/\s/g,'')}`} className="text-2xl font-bold text-[#2C1810] hover:text-[#6F4E37] block mt-1">{business.phone}</a>
                  <div className="flex flex-wrap gap-3 mt-4">
                    <a href={`tel:${business.phone.replace(/\s/g,'')}`} className="bg-[#6F4E37] text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#5a3d2b] transition">
                      <i className="fas fa-phone mr-2"></i> Call Now
                    </a>
                    <a href="#" className="border-2 border-[#6F4E37] text-[#6F4E37] px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#6F4E37] hover:text-white transition">
                      <i className="fas fa-envelope mr-2"></i> Email Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className="bg-[#2C1810] text-[#F5E6D3] py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h4 className="text-xl font-bold mb-3">Sun Infosystem</h4>
            <p className="text-sm opacity-80">Identity solutions for modern businesses.</p>
          </div>
          <div>
            <h5 className="font-semibold mb-3">Quick Links</h5>
            <ul className="space-y-2 text-sm opacity-80">
              <li><a href="#products" className="hover:opacity-100">Products</a></li>
              <li><a href="#services" className="hover:opacity-100">Services</a></li>
              <li><a href="#about" className="hover:opacity-100">About</a></li>
              <li><a href="#contact" className="hover:opacity-100">Contact</a></li>
            </ul>
          </div>
          <div>
            <h5 className="font-semibold mb-3">Contact</h5>
            <ul className="space-y-2 text-sm opacity-80">
              <li><i className="fas fa-phone mr-2"></i> {business.phone}</li>
              <li><i className="fas fa-envelope mr-2"></i> info@suninfosystem.com</li>
            </ul>
          </div>
          {/* <div>
            <h5 className="font-semibold mb-3">Follow Us</h5>
            <div className="flex gap-4 text-xl">
              <a href="#" className="hover:text-white"><i className="fab fa-instagram"></i></a>
              <a href="#" className="hover:text-white"><i className="fab fa-facebook"></i></a>
              <a href="#" className="hover:text-white"><i className="fab fa-twitter"></i></a>
            </div>
          </div> */}
        </div>
        <div className="text-center text-sm opacity-60 mt-8 border-t border-white/10 pt-6">
          &copy; {new Date().getFullYear()} Sun Infosystem. All rights reserved.
        </div>
      </footer>

    </div>
  );
}